import React, { Fragment } from 'react'
import styled from 'styled-components'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import { FormattedMessage } from 'react-intl'
import { Text } from 'app/common/typography'
import { AnimatedProgressBar } from 'app/common/animated-progress-bar'

const { error } = oldColors

type Props = {
    step: number,
    descriptionKey: string
}

const OrderTimeline = ({ step, descriptionKey }: Props) => {
    const steps = [1, 2, 3, 4]

    const renderSegment = (segmentNumber, i) => {
        return (
            <Fragment key={i}>
                <AnimatedProgressBar
                    height="8px"
                    width="50px"
                    borderRadius="5px"
                    backgroundColor={colors.lightGrey}
                    progressColor={
                        segmentNumber === 1
                            ? step >= 1
                                ? colors.crunchyGreen
                                : error
                            : step >= segmentNumber && colors.crunchyGreen
                    }
                    inProgress={
                        segmentNumber === 4 ? false : step === segmentNumber
                    }
                />
            </Fragment>
        )
    }

    return (
        <MainContainer>
            <StepsContainer>{steps.map(renderSegment)}</StepsContainer>
            <FormattedMessage id={descriptionKey}>
                {(label: string) => <StyledText>{label}</StyledText>}
            </FormattedMessage>
        </MainContainer>
    )
}

const MainContainer = styled.div`
    margin: 10px 0;
`

const StepsContainer = styled.div`
    display: flex;
    margin-bottom: 10px;
`

const StyledText = styled(Text)`
    font-weight: bold;
`

export { OrderTimeline }
